function n() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (r) => {
    const x = Math.random() * 16 | 0;
    return (r === "x" ? x : x & 3 | 8).toString(16);
  });
}
export {
  n as uuidv4
};
